module.exports = __webpack_public_path__ + "img/yhqicon @2x.f8bd0b87.png";